import { EnhancedSnackbar, Spacer } from "@websential/cosmic-v20";

import { AccountFormLayout } from "../AccountFormLayout";
import { AuthService } from "../../services/AuthService";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { INITIAL_SNACKBAR_DATA } from "../../common/constants";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import SecurityIcon from "@mui/icons-material/Security";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import Typography from "@mui/material/Typography";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const AuthSelectionScreenComponent = () => {
	const navigate = useNavigate();
	const accessToken = localStorage.getItem("accessToken");
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);

	const { mutate: triggerAuth } = useMutation({
		mutationFn: async (selectedAuthMethod: "phone" | "google" | "backup") => {
			if (!accessToken) throw new Error("Access token missing");

			if (selectedAuthMethod === "phone") {
				const response = await AuthService.CreateOtpByMessege(accessToken);

				if (
					response?.status === false &&
					response?.message === "Phone number not found add phone first"
				) {
					navigate("/add-phone-validation");
				} else {
					navigate("/phone-otp-validation", { state: accessToken });
				}
			} else if (selectedAuthMethod === "google") {
				navigate("/google-auth-validation", { state: { accessToken } });
			} else if (selectedAuthMethod === "backup") {
				navigate("/backup-code-validation", { state: { accessToken } });
			}
		},
		onError: (error: any) => {
			setSnackbarData({
				open: true,
				message: error?.message || "Something went wrong",
				severity: "error",
			});
		},
	});

	const handleSelect = (method: "phone" | "google" | "backup") => {
		triggerAuth(method);
	};

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") return;
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	return (
		<>
			<Grid container direction="column" alignItems="center" spacing={2} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				{/* <Grid width="100%"> */}
				{/* <Grid container spacing={2} direction="column" size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}> */}
				{/* Phone Option */}
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Box
						onClick={() => handleSelect("phone")}
						sx={{
							border: "1px solid #ccc",
							borderRadius: "25px",
							p: 2,
							display: "flex",
							alignItems: "center",
							width: "100%",
							cursor: "pointer",
							backgroundColor: "#fff",
							transition: "0.3s",
							"&:hover": {
								boxShadow: "0 0 0 2px rgb(25, 118, 210)",
							},
						}}
					>
						<PhoneAndroidIcon
							color="action"
							fontSize="medium"
							sx={{ mr: 4, ml: 2 }}
						/>
						<Box>
							<Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
								Phone
							</Typography>
							<Typography variant="body2" sx={{ color: "text.secondary" }}>
								Receive a code via SMS
							</Typography>
						</Box>
					</Box>
				</Grid>

				<Spacer y={1} />

				{/* Google Authenticator Option */}
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Box
						onClick={() => handleSelect("google")}
						sx={{
							border: "1px solid #ccc",
							borderRadius: "25px",
							p: 2,
							display: "flex",
							alignItems: "center",
							width: "100%",
							cursor: "pointer",
							backgroundColor: "#fff",
							transition: "0.3s",
							"&:hover": {
								boxShadow: "0 0 0 2px rgb(25, 118, 210)",
							},
						}}
					>
						<SecurityIcon
							color="action"
							fontSize="medium"
							sx={{ mr: 4, ml: 2 }}
						/>
						<Box>
							<Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
								Google Authenticator
							</Typography>
							<Typography variant="body2" sx={{ color: "text.secondary" }}>
								Use the Google Authenticator app
							</Typography>
						</Box>
					</Box>
				</Grid>

				{/* <Spacer y={3}/>
            <Grid item>
              <Box
                onClick={() => handleSelect("backup")}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "25px",
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  transition: "0.3s",
                  "&:hover": {
                    boxShadow: "0 0 0 2px rgb(25, 118, 210)",
                  },
                }}
              >
                <TextSnippetIcon
                  color="action"
                  fontSize="medium"
                  sx={{ mr: 4, ml: 2 }}
                />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                    Backup Codes
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Enter one of your backup codes
                  </Typography>
                </Box>
              </Box>
            </Grid> */}
				{/* </Grid> */}
				{/* </Grid> */}
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId="login-form-snackbar"
				open={snackbarData.open}
				autoHide={true}
			/>
		</>
	);
};

export const AuthSelectionScreenForm = () => {
	return (
		<AccountFormLayout
			title="Choose verification method"
			subtitle="Already verified 2FA Authentication?"
			subtitleLinkText="Sign In."
			subtitleLinkNavigateTo="/login"
			form={<AuthSelectionScreenComponent />}
		/>
	);
};

